const time = {
    "周": "tuần",
    "天": "ngày",
    "小时": "giờ",
    "分钟": "phút",
    "刚刚": "vừa mới",
    "前": "trước",
    "昨天": "hôm qua",
    "星期一": "thứ hai",
    "星期二": "thứ ba",
    "星期三": "thứ tư",
    "星期四": "thứ năm",
    "星期五": "thứ sáu",
    "星期六": "thứ bảy",
    "星期日": "chủ nhật",
}
  
export default time;